import React from 'react';

const WrapperCard = ({ background = 'white', children, customClasses = '' }) => {
	return <div className={`rounded bg-${background} min-w-[200px] shadow-lg ${customClasses}`}>{children}</div>;
};

export default WrapperCard;
